import React, { Fragment } from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import './DealReassignModal.scss';
/**
 * @component DealReassignOnLoadModal
 * @since 1.0.0
 * @hidden
 */
export function DealReassignOnLoadModal(props) {
    const { onClose, onConfirm, currentUserName } = props;
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { label: t('Cancel'), onPress: onClose }),
        React.createElement("div", { className: "deal-reassign-modal-button-container" },
            React.createElement(Button, { style: "primary", label: t('Reassign to me'), onPress: onConfirm }))));
    return (React.createElement("div", { className: "deal-reassign-modal" },
        React.createElement(Modal, { picto: "user-check", title: t('Reassign Quote'), onClose: onClose, showFooterAction: true, footerActions: footerActions },
            React.createElement("div", { className: "deal-reassign-modal-content" },
                React.createElement("p", null, t('This quote is not assigned to you. Would you like to reassign it to yourself?')),
                currentUserName && (React.createElement("p", null,
                    React.createElement("strong", null,
                        t('Current user'),
                        ": "),
                    currentUserName))))));
}
